var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { t } from 'helpers/i18n';
import { Select } from 'elements';
class Filter extends Component {
    constructor() {
        super(...arguments);
        this.handleSelect = (event) => {
            this.props.onSelect(Number(event.target.value));
        };
    }
    render() {
        const _a = this.props, { filters, selectedFilter, onSelect } = _a, props = __rest(_a, ["filters", "selectedFilter", "onSelect"]);
        return (React.createElement(Select, Object.assign({}, props, { onChange: this.handleSelect, value: '0', underline: false, options: filters.map((filter, index) => ({
                name: t(filter.name),
                value: index
            })) })));
    }
}
export default Filter;



//////////////////
// WEBPACK FOOTER
// ./src/components/Filter.tsx
// module id = 478
// module chunks = 0